import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CreateUpdateDefaultComponent} from "./create-update-default.component";
import {ErrorCardModule} from "../../../../components/common/error-card/error-card.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {SuccessCardModule} from "../../../../components/common/success-card/success-card.module";
import {ContentDirective} from "../../../../shared/directives/content.directive";
import {ContentModule} from "../../../../shared/directives/content.module";
import {ConfirmationButtonModule} from "../../../../components/common/button/confirmation-button/confirmation-button.module";
import {ButtonModule} from "../button/button.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ErrorCardModule,
        LoadingModule,
        SuccessCardModule,
        ContentModule,
        ConfirmationButtonModule,
        ButtonModule,
    ],
    declarations: [
        CreateUpdateDefaultComponent,
    ],
    exports: [CreateUpdateDefaultComponent, ContentDirective]
})
export class CreateUpdateDefaultModule {}